// import { FilingNote } from './FilingNote';

export interface ExtendedFilingDetail {
  drafts?: any[];
  additionalAgencyEmail?: string;
  // affidavitContainerName?: string;
  // affidavitBlobName?: string;
  affiliationOfPersonCommenting?: string;
  agencyId?: string;
  agencyEmail?: string;
  agencyName?: string;
  agencyNotes?: string;
  agencyPhone?: string;
  agencyResponse?: string;
  certificationStatement?: string;
  changesBetweenNoticeAndHearing?: string;
  chapterSubject?: string;
  descriptionAndSummaryOfRuleChanges?: string;
  explanatoryDate?: Date;
  // descriptionOfImpact?: string;
  directorsSignature?: string;
  fteImpact?: string;
  hearingAddressLine1?: string;
  hearingAddressLine2?: string;
  hearingCity?: string;
  hearingComments?: string;
  hearingDate?: Date;
  hearingState?: string;
  hearingZip?: string;
  hearingEMeetingInfo?: string;
  hearingSummaryContainerName?: string;
  hearingSummaryBlobName?: string;
  // indeterminableExplanation?: string;
  issuesOfUniqueInterest?: string;
  isUnfundedMandate?: boolean;
  nameOfPersonCommenting?: string;
  nameOfPersonSigningCertificate?: string;
  preambleAndCertificateContainerName?: string;
  preambleAndCertificateBlobName?: string;
  preparerContactInfo?: string;
  reasonForAdoptionAmendmentRepeal?: string;
  ruleChangeTypeId?: number;
  timeOfHearing?: string;
  titleOfSigner?: string;
  titleSubject?: string;

  agencyHearingContactName?: string;
  agencyHearingContactEmail?: string;
  agencyHearingContactPhone?: string;

  accessibilityProvisionsContactPerson?: string;
  accessibilityProvisionsPhoneNumber?: string;

  agencyInfoName?: string;
  agencyInfoDivision?: string;
  agencyInfoAddress?: string;
  agencyInfoCity?: string;
  agencyInfoState?: string;
  agencyInfoZip?: string;
  agencyInfoPhone?: string;

  certOfAdoptSigner?: string;
  certOfAdoptTitleOfSigner?: string;
  certOfAdoptRuleChangeTypeId?: number;
  certOfAdoptPublicHearingHeldOn?: Date;
  certOfAdoptNoticeSentOn?: Date;
  certOfAdoptDate?: Date;

  fiscalImpactStatementCreatedOn?: Date;
  indeterminableImpactDesc?: string;
  politicalSubdivisionImpactDesc?: string;
  regulatedPublicImpactDesc?: string;
  stateAgencyImpactDesc?: string;
  politicalSubdivisionHasNoFiscalImpact?: boolean;
  politicalSubdivisionHasIncreasedCost?: boolean;
  politicalSubdivisionHasDecreasedCost?: boolean;
  politicalSubdivisionHasIncreasedRevenue?: boolean;
  politicalSubdivisionHasDecreasedRevenue?: boolean;
  politicalSubdivisionIsIndeterminable?: boolean;
  regulatedPublicHasNoFiscalImpact?: boolean;
  regulatedPublicHasIncreasedCost?: boolean;
  regulatedPublicHasDecreasedCost?: boolean;
  regulatedPublicHasIncreasedRevenue?: boolean;
  regulatedPublicHasDecreasedRevenue?: boolean;
  regulatedPublicIsIndeterminable?: boolean;
  stateAgencyHasNoFiscalImpact?: boolean;
  stateAgencyHasIncreasedCost?: boolean;
  stateAgencyHasDecreasedCost?: boolean;
  stateAgencyHasIncreasedRevenue?: boolean;
  stateAgencyHasDecreasedRevenue?: boolean;
  stateAgencyIsIndeterminable?: boolean;

  hearingNoticeAttachments?: any[];
  hearingSummaryAttachments?: any[];
  affidavitOfPublicationAttachments?: any[];
}

export const ConstructEmptyExtendedFilingDetail = () => {
  let extendedFilingDetail : ExtendedFilingDetail = {
    drafts: [],
    additionalAgencyEmail: '',
    affiliationOfPersonCommenting: '',
    agencyId: '',
    agencyEmail: '',
    agencyName: '',
    agencyNotes: '',
    agencyPhone: '',
    agencyResponse: '',
    certificationStatement: '',
    changesBetweenNoticeAndHearing: '',
    chapterSubject: '',
    descriptionAndSummaryOfRuleChanges: '',
    directorsSignature: '',
    fteImpact: '',
    hearingAddressLine1: '',
    hearingAddressLine2: '',
    hearingCity: '',
    hearingComments: '',
    hearingDate: new Date(),
    hearingState: '',
    hearingZip: '',
    hearingSummaryContainerName: '',
    hearingSummaryBlobName: '',
    issuesOfUniqueInterest: '',
    isUnfundedMandate: false,
    nameOfPersonCommenting: '',
    nameOfPersonSigningCertificate: '',
    preambleAndCertificateContainerName: '',
    preambleAndCertificateBlobName: '',
    preparerContactInfo: '',
    reasonForAdoptionAmendmentRepeal: '',
    timeOfHearing: '',
    titleOfSigner: '',
    titleSubject: '',
    fiscalImpactStatementCreatedOn: new Date(),
    indeterminableImpactDesc: '',
    politicalSubdivisionImpactDesc: '',
    regulatedPublicImpactDesc: '',
    stateAgencyImpactDesc: '',
    politicalSubdivisionHasNoFiscalImpact: false,
    politicalSubdivisionHasIncreasedCost: false,
    politicalSubdivisionHasDecreasedCost: false,
    politicalSubdivisionHasIncreasedRevenue: false,
    politicalSubdivisionHasDecreasedRevenue: false,
    politicalSubdivisionIsIndeterminable: false,
    regulatedPublicHasNoFiscalImpact: false,
    regulatedPublicHasIncreasedCost: false,
    regulatedPublicHasDecreasedCost: false,
    regulatedPublicHasIncreasedRevenue: false,
    regulatedPublicHasDecreasedRevenue: false,
    regulatedPublicIsIndeterminable: false,
    stateAgencyHasNoFiscalImpact: false,
    stateAgencyHasIncreasedCost: false,
    stateAgencyHasDecreasedCost: false,
    stateAgencyHasIncreasedRevenue: false,
    stateAgencyHasDecreasedRevenue: false,
    stateAgencyIsIndeterminable: false,
    hearingNoticeAttachments: [],
    hearingSummaryAttachments: [],
    affidavitOfPublicationAttachments: [],

    accessibilityProvisionsContactPerson: '',
    accessibilityProvisionsPhoneNumber: '',

    agencyInfoName: '',
    agencyInfoDivision: '',
    agencyInfoAddress: '',
    agencyInfoCity: '',
    agencyInfoState: '',
    agencyInfoZip: '',
    agencyInfoPhone: '',

    certOfAdoptSigner: '',
    certOfAdoptTitleOfSigner: '',
    certOfAdoptPublicHearingHeldOn: new Date(),
    certOfAdoptNoticeSentOn: new Date()
  }
  return extendedFilingDetail;
}
